import type { MeterItem } from 'primeng/types/metergroup';

export const CREDITS_METER_COLORS = {
  available: 'var(--secondary)',
  availableExtra: '#668CF6',
  reserved: '#fd9326',
  used: '#c6c7cb',
} as const;

export function creditsUsedAmount(
  total: number,
  left: number,
  reserved: number,
): number {
  return Math.max(0, total - reserved - left);
}

export function creditsMeterMax(
  left: number,
  reserved: number,
  used: number,
  total: number,
): number {
  return Math.max(left + reserved + used, total, 1);
}

/**
 * Builds the meter segments for the credits counter, splitting the available
 * credits into subscription and manually booked (extra) credits.
 *
 * @param {object} params Credit amounts and the translation callback.
 * @param {number} params.leftSubscription Available credits granted by the subscription.
 * @param {number} params.leftExtra Available credits booked on top of the subscription.
 * @param {number} params.reserved Reserved credits.
 * @param {number} params.used Used credits.
 * @param {(key: string) => string} params.translate Translation callback for the segment labels.
 * @returns {MeterItem[]} Meter segments in display order.
 */
export function buildCreditsMeterItems(params: {
  leftSubscription: number;
  leftExtra: number;
  reserved: number;
  used: number;
  translate: (key: string) => string;
}): MeterItem[] {
  return [
    {
      label: params.translate(
        'company-tool.snippets.credits-counter.available-subscription-label',
      ),
      value: params.leftSubscription,
      color: CREDITS_METER_COLORS.available,
    },
    {
      label: params.translate(
        'company-tool.snippets.credits-counter.available-extra-label',
      ),
      value: params.leftExtra,
      color: CREDITS_METER_COLORS.availableExtra,
    },
    {
      label: params.translate(
        'company-tool.snippets.credits-counter.reserved-label',
      ),
      value: params.reserved,
      color: CREDITS_METER_COLORS.reserved,
    },
    {
      label: params.translate(
        'company-tool.snippets.credits-counter.used-label',
      ),
      value: params.used,
      color: CREDITS_METER_COLORS.used,
    },
  ];
}
